import * as types from './action-types';
import URC from 'ui-react-common';

const api = URC.services.coreAPIInstance;

const fetchDisclosures = (requiredFor) => {
    const body = {
        requiredFor,
    };
    return {
        asyncAction: () => api.fetchDisclosures(body),
        type: types.DISCLOSURES,
    };
};

export default { fetchDisclosures };
